import React, { useRef, useState, useEffect, createRef } from 'react';
import classnames from 'classnames';
import getRandomInt from '@/utils/getRandomInt';

import './style.css';

const bubbles = [
  {
    label: 'Music',
    x: 0.1,
    y: 0.3,
    d: 0.75,
    color: '#fff',
    bgColor: 'linear-gradient(180deg, #003698 0%, #463CC5 100%)',
  },
  {
    label: 'Science',
    x: 0.76,
    y: 0.68,
    d: 0.64,
    color: '#fff',
    bgColor: 'linear-gradient(180deg, #003698 0%, #463CC5 100%)',
  },
  {
    label: 'Sports',
    x: 0.15,
    y: 0.95,
    d: 0.5,
    color: '#002680',
    bgColor: '#fff',
  },
  {
    label: 'Art',
    x: 0.54,
    y: 1.2,
    d: 0.375,
    color: '#002680',
    bgColor: '#fff',
  },
  {
    label: 'Food',
    x: 0.9,
    y: 1.15,
    d: 0.325,
    color: '#002680',
    bgColor: '#fff',
  },
];

export default ({ size }) => {
  return (
    <ul className="hp-bubbles-wrapper">
      {bubbles.map(({ label, x, y, d, color, bgColor }, idx) => (
        <li
          key={idx}
          className={classnames('hp-bubble')}
          style={{
            left: (x + 0.12) * size - (d / 2) * size,
            top: y * size - (d / 2) * size,
            width: d * size,
            height: d * size,
            background: bgColor,
            color,
            animationDelay: `${(idx + 1) * getRandomInt(200, 500)}ms`,
            animationDuration: `${getRandomInt(7, 13)}s`,
          }}
        >
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
};
